import React, { Component } from "react";
import logo from "./logo.svg";
import "./App.css";
import Routes from "./components/Routes";
import { BrowserRouter, Route } from "react-router-dom";
import * as firebase from "firebase";
import "firebase/database";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATA_BASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
};

class App extends Component {
  componentWillMount() {
    console.log("[Firebase Config]", {
      apiKey: firebaseConfig.apiKey ? "✅ 있음" : "❌ 없음",
      authDomain: firebaseConfig.authDomain ? "✅ 있음" : "❌ 없음",
      databaseURL: firebaseConfig.databaseURL || "❌ 없음",
      projectId: firebaseConfig.projectId ? "✅ 있음" : "❌ 없음",
      storageBucket: firebaseConfig.storageBucket ? "✅ 있음" : "❌ 없음",
    });
    if (!firebase.apps.length) {
      try {
        firebase.initializeApp(firebaseConfig);
        console.log("[Firebase] ✅ 초기화 성공");
      } catch (e) {
        console.error("[Firebase] ❌ 초기화 실패:", e);
      }
    } else {
      console.log("[Firebase] 이미 초기화됨");
    }
  }

  render() {
    return (
      <div>
        <BrowserRouter>
          <Routes />
        </BrowserRouter>
      </div>
    );
  }
}

export default App;
